import './HongCombobox.scss';
import React, { forwardRef } from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const HongCombobox = ({ label, value, onChange, options, placeholder='', color='#888' }) => {
  return (
    <FormControl variant="outlined" fullWidth className="custom-form-control">
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        // onChange={onChange}
        onChange={(event) => {
          const selectedValue = event.target.value;
          const selectedLabel = options.find(option => option.value === selectedValue)?.label || '';
          onChange(selectedValue, selectedLabel); // value와 label을 함께 전달
        }}

        label={label}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return <span className="combobox-placeholder" style={{ color: `${color}` }}>{placeholder}</span>;
          }
          return options.find(option => option.value === selected)?.label || '';
        }}
      >
        {options.map((option, index) => (
          <MenuItem 
              key={index} 
              value={option.value} 
              label={option.label}>
              {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default HongCombobox;
